import '../Content/css/banner.css'
import '../Content/css/index.css'
import '../Content/js/banner.js'
import '../Content/js/swiper.min.js'
$(document).ready(function() {
	var swiper = new Swiper('.swiper-container', {
		pagination: '.swiper-pagination',
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		slidesPerView: 1,
		paginationClickable: true,
		spaceBetween: 30,
		loop: true,
		spaceBetween: 30,
		keyboardControl: true,
		centeredSlides: true,
		autoplay: 2500,
		autoplayDisableOnInteraction: false
	});
	$(".video-list a").click(function(e){
		var a_href=$(this).attr("href");
		$(".video_detail").addClass("video_detail_animation").removeClass("video_detail_close");
		$(".video_detail iframe").attr("src",a_href);
		return false;
	});
	$("#video_close").click(function(){
		$(".video_detail").removeClass("video_detail_animation").addClass("video_detail_close");
		$(".video_detail iframe").attr("src","");
	})
});


// WEBPACK FOOTER //
// ./E:/airwheel.net/entry/index.js